import { render, staticRenderFns } from "./SunIcon.vue?vue&type=template&id=c1ea38ba&"
import script from "./SunIcon.vue?vue&type=script&lang=js&"
export * from "./SunIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports